/**
 * Report column model shared by the app and the server: the two Reports tabs' field registries and
 * the per-field value formatters used by the tables and by exports (see `prescription-values.ts`,
 * `stock-movement-values.ts`). Kept in the engine so both sides format rows identically.
 */
/** fixed column widths in px, by field type (see CY-82) */
export const REPORT_COLUMN_WIDTH = {
    date: 120,
    number: 90,
    name: 160,
    longText: 200,
};
export const SELECTION_COLUMN_WIDTH = 48;
export function buildDisplayColumns(orderedFieldIds, fieldSet) {
    const columns = [];
    const byId = new Map(fieldSet.fields.map(field => [field.id, field]));
    for (const id of orderedFieldIds) {
        const field = byId.get(id);
        if (!field)
            continue;
        const prev = columns[columns.length - 1];
        const mergeWithPrev = field.cellGroup && prev && prev.fields[0]?.cellGroup === field.cellGroup;
        if (mergeWithPrev) {
            prev.fields.push(field);
            prev.width = Math.max(prev.width, REPORT_COLUMN_WIDTH[field.type]);
        }
        else {
            columns.push({
                key: field.id,
                fields: [field],
                width: REPORT_COLUMN_WIDTH[field.type],
                frozen: fieldSet.frozenFieldIds.includes(field.id),
            });
        }
    }
    // frozen columns stay on the left, so they are hoisted to the front (order kept within each group)
    return [...columns.filter(column => column.frozen), ...columns.filter(column => !column.frozen)];
}
/** Number of leading display columns marked frozen, so they can be pinned contiguously on the left. */
export function countLeadingFrozenColumns(columns) {
    let count = 0;
    for (const column of columns) {
        if (!column.frozen)
            break;
        count += 1;
    }
    return count;
}
//# sourceMappingURL=fields.js.map